<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="retailerPopup()"
          >新增销售商</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="merchantName" label="销售商名称">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.merchantName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="shortName" label="销售商简称"> </el-table-column>
      <el-table-column prop="license" label="生产许可证号"> </el-table-column>
      <el-table-column prop="contacts" label="联系人"> </el-table-column>
      <el-table-column prop="phoneNum" label="联系电话"> </el-table-column>
      <el-table-column prop="email" label="邮箱"> </el-table-column>
      <el-table-column prop="address" label="联系地址"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="retailerPopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="retailerDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 新增销售商 -->
    <el-dialog  :close-on-click-modal="false" :title="title" :visible.sync="retailerFormVisible" center>
      <el-form
        :model="retailerForm"
        :size="$store.state.formSize"
        :rules="retailerFormRules"
        ref="refretailerForm"
        label-width="140px"
      >
        <el-form-item label="销售商名称：" prop="merchantName">
          <el-input
            v-model="retailerForm.merchantName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="简称：">
          <el-input
            v-model="retailerForm.shortName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="生产许可证号：">
          <el-input
            v-model="retailerForm.license"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属区域：" prop="adminArea">
          <el-cascader
            :props="props"
            :placeholder="retailerForm.adminAreaStr"
            v-model="retailerForm.adminArea"
            @change="townSelect($event)"
            @expand-change="citySelect($event)"
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="地址：" prop="address">
          <el-input
            v-model="retailerForm.address"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="contacts">
          <el-input
            v-model="retailerForm.contacts"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phoneNum">
          <el-input
            v-model="retailerForm.phoneNum"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input
            v-model="retailerForm.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="传真：">
          <el-input v-model="retailerForm.fax" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="retailerForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawer" size="40%" :with-header="false">
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawer = false"></i>
          <span>供应商详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">供应商名称</td>
            <td>{{ detailDate.merchantName }}</td>
            <td class="list-item">供应商简称</td>
            <td>{{ detailDate.shortName }}</td>
          </tr>
          <tr>
            <td class="list-item">详细地址</td>
            <td>{{ detailDate.address }}</td>
            <td class="list-item">所属区域</td>
            <td>{{ detailDate.provinceName + detailDate.cityName + detailDate.countyName + detailDate.townName }}</td>
          </tr>
          <tr>
            <td class="list-item">联系人</td>
            <td>{{ detailDate.contacts }}</td>
            <td class="list-item">邮箱</td>
            <td>{{ detailDate.email }}</td>
          </tr>
          <tr>
            <td class="list-item">联系电话</td>
            <td>{{ detailDate.phoneNum }}</td>
            <td class="list-item">传真</td>
            <td>{{ detailDate.fax }}</td>
          </tr>
          <tr>
            <td class="list-item">创建时间</td>
            <td>{{ detailDate.createTime | format }}</td>
            <td class="list-item">备注</td>
            <td>{{ detailDate.remark }}</td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getTrackMerchant,
  putTrackMerchantRetailer,
  getTrackMerchantDetail,
  postTrackMerchantRetailer,
  deleteMerchantDel,
  delMerchantList
} from '@/api/merchant'
import { getCity } from '@/api/city'
const createForm = () => ({
  address: '',
  contacts: '',
  province: '',
  city: '',
  county: '',
  town: '',
  fax: '',
  email: '',
  license: '',
  merchantName: '',
  shortName: '',
  phoneNum: '',
  remark: '',
  adminArea: [],
  adminAreaStr: ''
})

export default {
  data() {
    return {
      retailerFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      drawer: false,
      detailDate: {},
      tableData: [],
      retailerForm: createForm(),
      currentID: null,
      isDisabled: false,
      retailerFormRules: {
        merchantName: [
          { required: true, message: '请输入销售商名称', trigger: 'blur' }
        ],
        phoneNum: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        adminArea: [
          { required: true, message: '请选择所属区域', trigger: 'blur' }
        ]
      },
      props: {
        // 获取管理区域城市tree
        emitPath: false,
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node
          let valueArr = []
          if (value) {
            valueArr = value.split(',')
          }
          getCity({
            code: valueArr[0] || '100000000'
          }).then(res => {
            const nodes = Array.from(res.data).map(item => ({
              label: item.name,
              value: item.code + ',' + item.id,
              code: item.code,
              // 判断最后一层
              leaf: item.type > 3
            }))
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)
          })
        }
      },
      loading: true,
      selectionID: []
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑销售商' : '新增销售商'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.retailerSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delMerchantList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getRetailerListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    hanleResetFormVals() {
      this.retailerFormVisible = false
      this.$set(this, 'retailerForm', createForm())
      this.$refs.refretailerForm.clearValidate()
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getRetailerListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getRetailerListData()
    },
    citySelect(event) {
      if (event.length > 2) {
        this.retailerForm.province = parseInt(event[0].split(',')[1])
        this.retailerForm.city = parseInt(event[1].split(',')[1])
        this.retailerForm.county = parseInt(event[2].split(',')[1])
      }
    },
    townSelect(event) {
      this.retailerForm.town = parseInt(event.split(',')[1])
    },
    // 删除销售商
    retailerDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteMerchantDel({
            id: id
          }).then(res => {
            if (res.status === 1) {
              this.$message.success('删除销售商成功')
              this.getRetailerListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/修改销售商
    retailerSubmit() {
      this.$refs.refretailerForm.validate(valid => {
        if (!valid) return false
        const changeRetailer = this.currentID
          ? postTrackMerchantRetailer
          : putTrackMerchantRetailer
        changeRetailer({
          address: this.retailerForm.address,
          contacts: this.retailerForm.contacts,
          province: this.retailerForm.province,
          city: this.retailerForm.city,
          county: this.retailerForm.county,
          town: this.retailerForm.town,
          fax: this.retailerForm.fax,
          email: this.retailerForm.email,
          license: this.retailerForm.license,
          merchantName: this.retailerForm.merchantName,
          shortName: this.retailerForm.shortName,
          phoneNum: this.retailerForm.phoneNum,
          remark: this.retailerForm.remark,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑销售商成功') : this.$message.success('新增销售商成功')
            this.retailerFormVisible = false
            this.getRetailerListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开表单
    retailerPopup(id) {
      this.$set(this, 'retailerForm', createForm())
      const isAdd = !id
      this.retailerFormVisible = true

      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getTrackMerchantDetail(2, id).then(res => {
          if (res.status === 1) {
            console.log(res)
            Object.keys(createForm()).forEach(key => {
              if (key in res.data) {
                this.retailerForm[key] = res.data[key]
              }
            })
            this.retailerForm.adminArea = [
              res.data.provincx,
              res.data.city,
              res.data.county,
              res.data.town
            ]
            this.retailerForm.adminAreaStr = [
              res.data.provinceName,
              res.data.cityName,
              res.data.countyName,
              res.data.townName
            ].join('/')
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getRetailerListData()
    },
    // 刷新数据表格
    refresh() {
      this.getRetailerListData()
      this.$message.success('数据刷新成功')
    },
    // 详情
    detailShow(id) {
      this.drawer = true
      getTrackMerchantDetail(2, id).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取销售商列表
    getRetailerListData() {
      this.loading = true
      getTrackMerchant({
        type: 2,
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    }
  },
  mounted() {
    this.getRetailerListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
